import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import { MessageAppearanceAckV2, MessageAppearanceAckV2Variables } from './__generated__/MessageAppearanceAckV2'

export const MESSAGE_APPEARANCE_ACK_V2_QUERY = gql`
  query MessageAppearanceAckV2($messageAppearanceId: String!) {
    messageAppearanceAckV2(messageAppearanceId: $messageAppearanceId) {
      messageAppearanceId
      clientTimestamp
      serverTimestamp
    }
  }
`

export const useMessageAppearanceAckV2 = (
  messageAppearanceId: string,
  { skip }: { skip?: boolean } = {}
) => {
  return useQuery<MessageAppearanceAckV2, MessageAppearanceAckV2Variables>(MESSAGE_APPEARANCE_ACK_V2_QUERY, {
    fetchPolicy: 'cache-and-network',
    variables: { messageAppearanceId },
    skip: skip ?? !messageAppearanceId
  })
}
